import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import type { PromotionScheduleStatusType } from '@/api/admin-promotions-types'
import { preloadListPromotions } from '@/api/react-query'
import { paginatedSearchWithSort } from '@/utils/route-utilities'

export const Route = createFileRoute('/_authenticated/_general/promotions')({
	validateSearch: paginatedSearchWithSort(['name', 'enabled', 'rank', 'startDate', 'endDate']).extend({
		salesChannels: z.array(z.string()).optional(),
		status: z.array(z.string()).optional()
	}),
	loaderDeps: ({ search: { limit, offset, q, sortBy, sortOrder, salesChannels, status } }) => ({
		limit,
		offset,
		q,
		sortBy,
		sortOrder,
		salesChannels,
		status
	}),
	loader: async ({ context, deps: { limit, offset, q, sortBy, sortOrder, salesChannels, status } }) =>
		await preloadListPromotions(context, {
			query: {
				limit: limit.toString(),
				offset: offset?.toString(),
				q,
				sortBy,
				sortOrder,
				salesChannels: salesChannels?.length ? salesChannels : undefined,
				status: (status?.length ? status : undefined) as PromotionScheduleStatusType[] | undefined
			}
		}),
	staticData: {
		crumb: ({ context: { L } }) => L.Promotions.Title()
	}
})
